// Small DOM and formatting helpers for the record flow.

export const $ = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

export function show(el, on = true) { if (el) el.hidden = !on; }

/** Read a <script type="application/json"> block rendered by the template. */
export function readJson(id) {
  const el = document.getElementById(id);
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch { return null; }
}

/** "00:00" style clock for the live timer. */
export function fmtClock(sec) {
  const s = Math.max(0, Math.floor(Number(sec) || 0));
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}

/** "1:05" style (playback progress). */
export function fmtShort(sec) {
  const s = Math.max(0, Math.floor(Number(sec) || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** Plain words for a length: "45 seconds", "1 minute", "2 minutes 5 seconds". Unknown -> "length not known". */
export function fmtLength(sec) {
  if (sec == null || !isFinite(sec) || sec <= 0) return 'length not known';
  const s = Math.max(1, Math.floor(sec)); // floor, like the mm:ss timer the person watched
  const m = Math.floor(s / 60), r = s % 60;
  const mins = m ? `${m} minute${m === 1 ? '' : 's'}` : '';
  const secs = r ? `${r} second${r === 1 ? '' : 's'}` : '';
  return [mins, secs].filter(Boolean).join(' ');
}

export function plural(n, one, many) { return `${n} ${n === 1 ? one : many}`; }

/**
 * Keep an abbreviated title with the word after it ("St. Theresa", "Fr. Larry", "Msgr. Elmer") by
 * joining them with a no-break space, so a heading never ends a line on "St.". Display text only.
 */
export function keepTitlesTogether(s) {
  return String(s == null ? '' : s).replace(/\b(St|Fr|Msgr|Mr|Mrs|Ms|Dr|Rev)\. (?=\S)/g, '$1.\u00a0');
}

/** Build an element: el('li', { class: 'x', 'data-a': 1 }, [child, 'text']). */
export function el(tag, attrs = {}, children = []) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs || {})) {
    if (v == null || v === false) continue;
    if (k === 'class') node.className = v;
    else if (k === 'text') node.textContent = v;
    else node.setAttribute(k, v === true ? '' : String(v));
  }
  for (const c of [].concat(children)) {
    if (c == null || c === false) continue;
    node.append(c instanceof Node ? c : document.createTextNode(String(c)));
  }
  return node;
}
